import React, { useEffect, useRef, useState } from 'react';
import Pesquisar from './Pesquisar';
import { Button, Card, notification, Spin } from 'antd';
import './TelaVendas.css'; // Assumindo que os estilos foram movidos para um arquivo CSS
import ModalItemSelecionado from './ModalItemSelecionado';
import FinalizarVenda from './FinalizarVenda';
import Leitor from './Leitor';
import TesteQr from './LeitorQRCode';
import LeitorQRCode from './LeitorQRCode';
import axios from 'axios';
import BuscarOrcamentos from './Orcamentos/BuscarOrcamentos';
import BuscarDelivery from './BuscarDelivery';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useConfigQuery } from '../../../queries/useConfig';
import axiosInstance from '../../../axiosInterceptor';
import BuscarVendas from './Operacoes/BuscarVendas';
import BuscarPedidosMkt from './Operacoes/BuscarPedidosMkt';

const TelaVendas = ({ produtos, setProdutos, pagamentoConcluido, setPagamentoConcluido, pagamentos, setPagamentos, consumidorIdentificado, setConsumidorIdentificado, consumidor, setConsumidor, pagItem, setPagItem }) => {
  const { data: config, error } = useConfigQuery();
  const [idPedidoMkt, setIdPedidoMkt] = useState("");

  const [vendaPuxada, setVendaPuxada] = useState(false);
  const [isPesquisar, setIsPesquisar] = useState(false);
  const [isFinalizarVenda, setIsFinalizarVenda] = useState(false);
  const [isBuscarOrcamento, setIsBuscarOrcamento] = useState(false);
  const [isBuscarVenda, setIsBuscarVenda] = useState(false);
  const [isBuscarPedidoMkt, setIsBuscarPedidoMkt] = useState(false);

  const [isBuscarDelivery, setIsBuscarDelivery] = useState(false);
  const [acresDescFreteConcluido, setAcresDescFreteConcluido] = useState(false);
  const [quantidadeDeItens, setQuantidadeDeItens] = useState(0);
  const [precoTotal, setPrecoTotal] = useState(0);
  const [totalSemFrete, setTotalSemFrete] = useState(0);
  const [totalDescontos, setTotalDescontos] = useState(0);
  const [totalAcrescimos, setTotalAcrescimos] = useState(0);
  const [subTotal, setSubtotal] = useState(0);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [isLoading, setIsLoading] = useState(false);
  const [nomeCupom, setNomeCupom] = useState('');
  const [documentoCupom, setDocumentoCupom] = useState('');
  const [numeroEvento, setnumeroEvento] = useState('');
  const [isModalVisibleBuscarOrcamento, setIsModalVisibleBuscarOrcamento] =
    useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [isLerCodigo, setIsLerCodigo] = useState(false);
  const [idOrcamento, setIdOrcamento] = useState('');
  const [travarAcrescimoDescFrete, setTravarAcrescimoDescFrete] = useState(false);

  const [cardAberto, setCardAberto] = useState('');
  const [consumidorIntegrado, setConsumidorIntegrado] = useState(null);
  const [tokenPedidoTechsapp, setTokenPedidoTechsapp] = useState(null);
  const [restauranteId, setRestauranteId] = useState('');
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [idVendedorOrcamento, setIdVendedorOrcamento] = useState(null);


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (restauranteId) {
      axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(options);
        });
    }
  }, [restauranteId]);


  const [acresDescFrete, setAcresDescFrete] = useState({
    acresTotal: '0',
    descTotal: '0',
    frete: '0',
  });


  const [cpfIntegracao, setCpfIntegracao] = useState(null);




  const [recalcular, setRecalcular] = useState(false);
  const inputRef = useRef(null);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const buscarProdutoPorCodigoBarras = async (codigoBarras) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };

      let response = {};
      let codigoDeBalanca = false;
      if (codigoBarras !== '') {
        if (codigoBarras.startsWith("2")) {
          console.log("O código de barras começa com 2");
          codigoDeBalanca = true;

        }

        const codigoParaBusca = extrairCodigoParaBusca(codigoBarras);

        setMensagem(`🔍 Procurando o código de barras: ${codigoBarras}`);
        response = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/produtos/buscarporean/${codigoParaBusca}`,
          options
        );

        console.log(response.data);
        if (response.data && response.status == 200) {
          if (codigoDeBalanca) {
            console.log(response.data.quantidade);
            console.log(response.data.valorAferido);
            console.log(response.data.preco);

            const { valorAferido, preco } = response.data;

            if (
              typeof valorAferido === 'number' &&
              typeof preco === 'number' &&
              preco !== 0
            ) {
              response.data.quantidade = (valorAferido / preco).toFixed(3);
            } else {
              response.data.quantidade = "0.000";
            }


            tratarProdutoBuscadoPorCodigoDeBalanca(response.data);

          } else {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
          }
          setMensagem(``);
        } else {

          response = await axios.get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/produtos/buscarporcod/${codigoParaBusca}`,
            options
          );

          if (response.data && response.status == 200) {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
            setMensagem(``);
          }

          if (response.status != 200) {
            setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
          }


        }

      }
    } catch (error) {
      console.error('Erro ao buscar produto por EAN:', error);
      if (error.status == 404) {
        setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
      }

    }

  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const valor = e.target.value.trim();
      if (valor) {
        buscarProdutoPorCodigoBarras(valor);
        e.target.value = ''; // limpa o campo
        inputRef.current.focus(); // volta o foco
      }
    }
  };

  const handlePesquisarClick = () => {
    setIsPesquisar(true); // Mostrar a tela de pesquisa
  };

  const handleVoltarClick = () => {
    setIsPesquisar(false);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const handleVoltarBuscarDeliveryClick = () => {
    setIsBuscarDelivery(false); // Voltar para a tela de vendas
  };

  /* const trataProdutos = produto => {
     setProdutos([...produtos, produto]);
 
   };*/
  function temPrecoZeradoOuNulo(produtos) {
    return produtos.some(produto => produto.preco === 0 || produto.preco === null);
  }

  /* const trataProdutos = (entrada) => {
     console.log(entrada);
     const novosProdutos = Array.isArray(entrada) ? entrada : [entrada];
     setProdutos((produtosAtuais) => [...produtosAtuais, ...novosProdutos]);
     setTimeout(() => {
       inputRef.current?.focus();
     }, 100); // pequeno delay para garantir que o DOM já está pronto
   };*/

  const novoUid = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

  const trataProdutos = (entrada) => {
    const arr = Array.isArray(entrada) ? entrada : [entrada];

    const novosProdutos = arr.map(p => ({
      ...p,                 // clona
      _uid: novoUid(),      // id único por linha
    }));

    setProdutos(prev => [...prev, ...novosProdutos]);

    setTimeout(() => inputRef.current?.focus(), 100);
  };



  const tratarProdutoBuscadoPorEan = item => {
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  const toNumber = (v) => {
    if (v == null) return NaN;
    const s = String(v).trim().replace(',', '.').replace(/[^\d.]/g, '');
    return Number(s);
  };

  const extrairCodigoParaBusca = (codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    if (cb.includes('$')) {
      const [, codigo] = cb.split('$');   // pega depois do $
      return String(codigo || '').trim();
    }

    if (cb.includes('*')) {
      const [, codigo] = cb.split('*');   // pega depois do *
      return String(codigo || '').trim();
    }

    return cb;
  };

  const tratarProdutoQuantidadeValor = (item, codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    // defaults
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;

    // "*" => 40*12  => quantidade=40, preco = preco*40
    if (cb.includes('*')) {
      const [qStr] = cb.split('*');
      const q = toNumber(qStr);

      if (Number.isFinite(q) && q > 0) {
        item.quantidade = q;
      }

      // "$" => 40$12  => 40 é valor total, 12 é só o código; qtd = total / precoUnit
    } else if (cb.includes('$')) {
      const [totalStr] = cb.split('$'); // ignora o "12" (código)
      const total = toNumber(totalStr);

      const precoUnit = toNumber(item.preco); // preço unitário do produto já buscado
      if (Number.isFinite(total) && total > 0 && Number.isFinite(precoUnit) && precoUnit > 0) {
        item.quantidade = total / precoUnit;

        // se quiser limitar casas (ex.: 3) para não ficar infinito:
        // item.quantidade = Number((total / precoUnit).toFixed(3));
      }
    }

    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };


  const tratarProdutoBuscadoPorCodigoDeBalanca = item => {
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };



  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const CalcularTotais = () => {
    var quantidadeDeItensAux = 0;
    var precoTotalAux = 0;
    var totalSemFreteAux = 0;
    var subTotalAux = 0;
    var totalDescontosAux = 0;
    var totalAcrescimosAux = 0;

    produtos.map(produto => {
      console.log(produto);
      quantidadeDeItensAux = parseFloat(quantidadeDeItensAux) + parseFloat(produto.quantidade);



      subTotalAux = subTotalAux + produto.preco * produto.quantidade;
      totalSemFreteAux =
        totalSemFreteAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo);

      precoTotalAux =
        precoTotalAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo) +
        parseFloat(produto.frete ? produto.frete : 0);

      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log(precoTotalAux);

      totalDescontosAux += parseFloat(produto.valorDesconto);
      totalAcrescimosAux += parseFloat(produto.valorAcrescimo);
    });

    setQuantidadeDeItens(quantidadeDeItensAux);
    setPrecoTotal(precoTotalAux);
    setTotalSemFrete(totalSemFreteAux);
    setSubtotal(subTotalAux);
    setTotalDescontos(totalDescontosAux);
    setTotalAcrescimos(totalAcrescimosAux);
  };

  const openModalItem = produto => {
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };
  useEffect(() => {
    CalcularTotais();
  }, [produtos, recalcular]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {(Array.isArray(config?.certificado?.Documentos) &&
          config.certificado.Documentos.length > 0 &&
          config.certificado.Documentos[0]?.CertDiasValido <= 90)
          ?
          <Button
            type="primary"
            onClick={async () => {
              console.log(config);
              const numero = "5511963697271";
              let mensagem = '';
              if (Array.isArray(config?.certificado?.Documentos) &&
                config.certificado.Documentos[0]?.CertDiasValido != null) {
                mensagem = "Quero renovar meu certificado digital para o TechsPDV";
              } else {
                mensagem = 'Certificado Digital Não Encontrado!';
              }

              const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
              window.open(url, "_blank");

              const options = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + accessToken,
                },
              };

              axiosInstance.get(
                `https://technfe-api.herokuapp.com/v1/enviarEmailRenovarCertificado/${config?.restaurante.nome}`,
                options
              );

            }}
            style={{ backgroundColor: "red", borderColor: "red", fontSize: '15px' }}
          >
            <span style={{ color: "white" }}>
              {config?.mensagemCertificado}
            </span>
          </Button>
          : ''}

      </div>
      <h1 style={{ textAlign: 'center', marginBottom: '5px', marginTop: 0 }}>Vendas</h1>

      {/* Se isPesquisar for verdadeiro, exibe o conteúdo de pesquisa */}
      {isBuscarPedidoMkt ? (
        <BuscarPedidosMkt
          closeModal={() => {
            setIsBuscarPedidoMkt(false);
          }}
          tratarProdutosOrcamento={async (orcamento) => {
            try {
              setIsLoading(true);
              setVendaPuxada(true);

              console.log(orcamento?.id);

              const cnpj = encodeURIComponent(config?.restaurante?.cnpj ?? "");

              const pedidoMkt = await axios.get(

                `https://apimarket.pedtech.com.br/v1/pedidos/${orcamento?.id}/${cnpj}`,
                {
                  headers: {
                    token: config?.tokenMarketplace,
                  },
                  // signal: controller.signal,
                }
              );
              setIdPedidoMkt(orcamento?.id || "");

              console.log("Pedidos MKT:", pedidoMkt.data);

              if (pedidoMkt.data.paymentMethods?.length > 0) {
                const options = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                  },
                };

                const pagamentosAux = await Promise.all(
                  pedidoMkt.data.paymentMethods.map(async (pagamento) => {
                    try {
                      // ✅ se o endpoint é por-cardbrand, use o cardbrand
                      const method = encodeURIComponent(pagamento.method ?? "0");
                      const cardbrand = encodeURIComponent(pagamento.cardBrand ?? "0");
                      const meiosDePagamentoMkt = await axiosInstance.get(
                        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/meios-pagamento-marketplace/por-method/${method}/por-cardbrand/${cardbrand}`,
                        options
                      );

                      if (meiosDePagamentoMkt.data?.length > 0) {
                        const m = meiosDePagamentoMkt.data[0];
                        return {
                          tipo: m.codigo,
                          tipoNome: m.descricao,
                          valor: pagamento.value,
                        };
                      }

                      return { tipo: "99", tipoNome: "Outros", valor: pagamento.value };
                    } catch (e) {
                      return { tipo: "99", tipoNome: "Outros", valor: pagamento.value };
                    }
                  })
                );

                setPagamentos(pagamentosAux);

                const pagItemAux = pagamentosAux.map((p) => ({
                  tPag: p.tipo,
                  vPag: Number(p.valor || 0).toFixed(2),
                  xPag: p.tipoNome,
                }));

                setPagItem(pagItemAux);
                setPagamentoConcluido(true);
              }


              console.log('orcamento');

              pedidoMkt.data.orderItems.map(async produto => {
                console.log(produto);

                try {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };
                  const body = {
                    texto: `${produto.sku}`
                  }
                  const response = await axios.post(
                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${config.restaurante.id}/produtos/sku?page=${0}`, body,
                    options,
                  );

                  const produtosAux = produtos;
                  console.log(response.data);
                  if (response.data._embedded.produtos.length > 0) {
                    let produtoTechspdv = response.data._embedded.produtos[0];
                    console.log(produtoTechspdv);
                    function validarDocumento(documento) {
                      console.log(documento);
                      // Remover caracteres não numéricos
                      documento = documento.replace(/[^\d]+/g, '');

                      // Verificar se o documento é um CPF
                      if (documento.length === 11) {
                        let cpf = documento;
                        let add = 0;
                        for (let i = 0; i < 9; i++) {
                          add += parseInt(cpf.charAt(i)) * (10 - i);
                        }
                        let rev = 11 - (add % 11);
                        if (rev === 10 || rev === 11) rev = 0;
                        if (rev !== parseInt(cpf.charAt(9))) return false;

                        add = 0;
                        for (let i = 0; i < 10; i++) {
                          add += parseInt(cpf.charAt(i)) * (11 - i);
                        }
                        rev = 11 - (add % 11);
                        if (rev === 10 || rev === 11) rev = 0;
                        if (rev !== parseInt(cpf.charAt(10))) return false;

                        return true;
                      }

                      // Verificar se o documento é um CNPJ
                      else if (documento.length === 14) {
                        let cnpj = documento;
                        let tamanho = cnpj.length - 2;
                        let numeros = cnpj.substring(0, tamanho);
                        let digitos = cnpj.substring(tamanho);
                        let soma = 0;
                        let pos = tamanho - 7;
                        for (let i = tamanho; i >= 1; i--) {
                          soma += numeros.charAt(tamanho - i) * pos--;
                          if (pos < 2) pos = 9;
                        }
                        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                        if (resultado !== parseInt(digitos.charAt(0))) return false;

                        tamanho = tamanho + 1;
                        numeros = cnpj.substring(0, tamanho);
                        soma = 0;
                        pos = tamanho - 7;
                        for (let i = tamanho; i >= 1; i--) {
                          soma += numeros.charAt(tamanho - i) * pos--;
                          if (pos < 2) pos = 9;
                        }
                        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                        if (resultado !== parseInt(digitos.charAt(1))) return false;

                        return true;
                      }

                      // Se não for nem CPF nem CNPJ, retorna false
                      else {
                        return false;
                      }
                    }
                    console.log(pedidoMkt.data);
                    if (validarDocumento(pedidoMkt.data.billing.documentId)) {
                      console.log('Cpf valido');
                      if (accessToken) {
                        const options = {
                          headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + accessToken,
                          },
                        };

                        axios
                          .get(
                            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config.idLoja}/cpfcnpj/${pedidoMkt.data.billing.documentId}`,
                            options,
                          )
                          .then(async (consumidorResp) => {
                            console.log(
                              `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config.idLoja}/cpfcnpj/${pedidoMkt.data.billing.documentId}`,
                            );

                            if (consumidorResp) {
                              console.log(consumidorResp.data);
                              if (consumidorResp.data) {
                                notification.success({
                                  message: 'Sucesso',
                                  description: 'Cliente encontrado!!',
                                });
                                consumidorResp.data.nomeCompleto = pedidoMkt.data.shipping.recipientName;
                                consumidorResp.data.endereco.numero = pedidoMkt.data.shipping.streetNumber;
                                consumidorResp.data.endereco.logradouro = pedidoMkt.data.shipping.street;
                                consumidorResp.data.telefone = pedidoMkt.data.shipping.phone;
                                consumidorResp.data.endereco.cep = pedidoMkt.data.shipping.zipCode;
                                consumidorResp.data.endereco.cidade.estado = pedidoMkt.data.shipping.state;
                                consumidorResp.data.endereco.bairro = pedidoMkt.data.shipping.district;
                                consumidorResp.data.endereco.complemento = pedidoMkt.data.shipping.streetComplement;
                                consumidorResp.data.documentoCpfCnpj = pedidoMkt.data.billing.documentId;
                                consumidorResp.data.email = pedidoMkt.data.billing.email;
                                //      "city": "Praia Grande",
                                //    "country": "BRA",
                                setConsumidor(consumidorResp.data);
                                setConsumidorIdentificado(true);
                              } else {
                                const response = await axios.get(`https://viacep.com.br/ws/${pedidoMkt.data.shipping.zipCode}/json/`);
                                const { data } = response;
                                let estadoMkt = '';
                                if (data.ibge?.length === 7) {
                                  estadoMkt = data.ibge.substring(0, 2);
                                }





                                let cidadeCorrespondente = '';

                                const options = {
                                  headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    Authorization: 'Bearer ' + accessToken,
                                  },
                                };

                                await axios
                                  .get(
                                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/cidades/listarPorEstadoCuf/${estadoMkt}`,
                                    options,
                                  )
                                  .then(response => {
                                    const comboCidades = response.data._embedded.cidades.map(cidade => ({
                                      label: cidade.nome,
                                      value: cidade.ibge,
                                      id: cidade.id,
                                    }));

                                    cidadeCorrespondente = comboCidades.find(c => c.value === data.ibge);

                                  });



                                console.log('718');



                                let consumidorAux = {
                                  ativo: true,
                                  nomeCompleto: pedidoMkt.data.shipping.recipientName,
                                  endereco: {
                                    numero: pedidoMkt.data.shipping.streetNumber,
                                    logradouro: pedidoMkt.data.shipping.street,
                                    cep: pedidoMkt.data.shipping.zipCode,
                                    bairro: pedidoMkt.data.shipping.district,
                                    complemento: pedidoMkt.data.shipping.streetComplement,
                                    cidade: {
                                      id: cidadeCorrespondente?.id || '',
                                    },
                                  },
                                  telefone: pedidoMkt.data.shipping.phone,
                                  documentoCpfCnpj: pedidoMkt.data.billing.documentId,
                                  email: "",
                                  documentoRgIE: "",


                                }


                                axios
                                  .post(
                                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config?.idLoja}`,
                                    consumidorAux,
                                    options,
                                  )
                                  .then(response => {

                                    console.log(consumidorAux);
                                    setConsumidor(response.data);
                                    setConsumidorIdentificado(true);
                                    notification.success({
                                      message: 'Sucesso',
                                      description: 'Cliente cadastrado!!',
                                    });
                                    // onClose();
                                  })
                              }
                            }
                          })
                      }
                    }



                    produtoTechspdv.preco = produto.price;
                    produtoTechspdv.quantidade = produto.quantity;
                    produtoTechspdv.acrescimo = 0;
                    produtoTechspdv.desconto = produto.discount;
                    produtoTechspdv.valorAcrescimo = 0;
                    produtoTechspdv.valorDesconto = produto.discount;
                    produtoTechspdv.frete = produto.freight ? produto.freight : "0";
                    produtoTechspdv.observacao = '';
                    produtoTechspdv.idVendedor = produto.idVendedor || '';
                    produtoTechspdv.nItemPed = '';
                    produtoTechspdv.xPed_item = '';
                    produtoTechspdv.travado = true;

                    console.log(produtoTechspdv);
                    produtosAux.push(produtoTechspdv);
                    CalcularTotais();
                  }

                  setProdutos(produtosAux);
                  let acresDescFreteAux = acresDescFrete;
                  acresDescFreteAux.frete = produto.freight;
                  setAcresDescFrete(acresDescFreteAux);

                } catch (error) {
                  setIsLoading(false);
                  console.error('Erro ao fazer a requisição:', error);
                  setVendaPuxada(false);
                }
              })


              setIsLoading(false);


              // aqui você trata o retorno e atualiza state
              // ex: setPedidosMkt(response.data);
            } catch (err) {
              console.error(err);
              // opcional: message.error("Erro ao buscar pedidos do marketplace");
            } finally {
              setIsLoading(false);
            }


          }}
        />

      ) : isBuscarOrcamento ? (
        <BuscarOrcamentos
          closeModal={() => {
            setIsBuscarOrcamento(false);
          }}
          tratarProdutosOrcamento={orcamento => {
            setIsLoading(true);
            setVendaPuxada(true);
            setIdVendedorOrcamento(orcamento.idVendedor);
            console.log(orcamento);

            function validarDocumento(documento) {
              // Remover caracteres não numéricos
              documento = documento.replace(/[^\d]+/g, '');

              // Verificar se o documento é um CPF
              if (documento.length === 11) {
                let cpf = documento;
                let add = 0;
                for (let i = 0; i < 9; i++) {
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(9))) return false;

                add = 0;
                for (let i = 0; i < 10; i++) {
                  add += parseInt(cpf.charAt(i)) * (11 - i);
                }
                rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(10))) return false;

                return true;
              }

              // Verificar se o documento é um CNPJ
              else if (documento.length === 14) {
                let cnpj = documento;
                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(1))) return false;

                return true;
              }

              // Se não for nem CPF nem CNPJ, retorna false
              else {
                return false;
              }
            }
            if (validarDocumento(orcamento.cpf)) {
              console.log('Cpf valido');
              if (accessToken) {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                axios
                  .get(
                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                    options,
                  )
                  .then(consumidorResp => {
                    console.log(
                      `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                    );

                    if (consumidorResp) {
                      console.log(consumidorResp.data);
                      if (consumidorResp.data) {
                        setConsumidor(consumidorResp.data);
                        setConsumidorIdentificado(true);
                      }
                    }
                  })
              }
            }

            if (produtos.length == 0) {
              const pagamentosAux = [];
              orcamento.pagamentos.map(pagamento => {

                const novoPagamento = {
                  tipo: pagamento.codigoFiscal,
                  tipoNome: pagamento.descricao,
                  valor: pagamento.valor,
                }
                pagamentosAux.push(novoPagamento);

              })
              console.log('Pagamentos');
              console.log(pagamentosAux);
              setPagamentos(pagamentosAux);
              let pagItemAux = new Array();
              pagamentosAux.map(pagamento => {
                const pagamentoFormatado = {
                  tPag: pagamento.tipo,
                  vPag: pagamento.valor.toFixed(2),
                  xPag: pagamento.tipoNome,
                };
                pagItemAux.push(pagamentoFormatado);
              });
              setPagItem(pagItemAux);

              setPagamentoConcluido(true);
            }

            console.log('orcamento');
            console.log(JSON.parse(orcamento.jsonDocFiscal).det.detItem);

            // pegue e normalize o detItem
            const detItems = JSON.parse(orcamento.jsonDocFiscal)?.det?.detItem;
            const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

            // índice por cProd (chave como string para evitar problemas de tipo)
            const detByCProd = new Map(
              detArray.map(it => [String(it?.prod?.cProd), it])
            );

            detArray.map(async item => {
              console.log(item);

              const produto = item?.prod;
              try {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                const response = await axios.get(
                  `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                  }/produtos/${produto.cProd}?page=${0}`,
                  options,
                );

                const produtosAux = produtos;
                if (response.data) {
                  console.log(response.data);

                  response.data.preco = produto.vUnCom;
                  response.data.quantidade = produto.qCOM;
                  response.data.acrescimo = produto.vOutro_item;
                  response.data.desconto = produto.vDesc;
                  response.data.valorAcrescimo = produto.vOutro_item;
                  response.data.valorDesconto = produto.vDesc;
                  response.data.frete = produto.vFrete ? produto.vFrete : 0;
                  response.data.observacao = item?.infADProd || '';
                  response.data.idVendedor = produto.idVendedor || '';
                  response.data.nItemPed = item?.nItemPed || '';
                  response.data.xPed_item = item?.xPed_item || '';

                  console.log(response.data);
                  produtosAux.push(response.data);
                  CalcularTotais();
                }

                setProdutos(produtosAux);

              } catch (error) {
                setIsLoading(false);
                console.error('Erro ao fazer a requisição:', error);
                setVendaPuxada(false);
              }
            })

            setIdOrcamento(orcamento.id);

            let acresDescFreteAux = acresDescFrete;
            acresDescFreteAux.frete = orcamento.valorFrete;
            setAcresDescFrete(acresDescFreteAux);
            console.log('orcamento');
            console.log('orcamento');
            console.log(orcamento);
            console.log('produtos');
            console.log(produtos);
            setIsLoading(false);

          }}
        />

      ) : isBuscarVenda ? (
        <BuscarVendas
          closeModal={() => {
            setIsBuscarVenda(false);
          }}
          tratarProdutosOrcamento={venda => {

            // setIdVendedorOrcamento(orcamento.idVendedor);
            console.log(venda);
            setIsLoading(true);
            setVendaPuxada(true);
            function validarDocumento(documento) {
              // Remover caracteres não numéricos
              documento = documento.replace(/[^\d]+/g, '');

              // Verificar se o documento é um CPF
              if (documento.length === 11) {
                let cpf = documento;
                let add = 0;
                for (let i = 0; i < 9; i++) {
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(9))) return false;

                add = 0;
                for (let i = 0; i < 10; i++) {
                  add += parseInt(cpf.charAt(i)) * (11 - i);
                }
                rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(10))) return false;

                return true;
              }

              // Verificar se o documento é um CNPJ
              else if (documento.length === 14) {
                let cnpj = documento;
                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(1))) return false;

                return true;
              }

              // Se não for nem CPF nem CNPJ, retorna false
              else {
                return false;
              }
            }
            if (validarDocumento(venda.cpf)) {
              console.log('Cpf valido');
              if (accessToken) {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                axios
                  .get(
                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${venda.idEmpresa}/cpfcnpj/${venda.cpf}`,
                    options,
                  )
                  .then(consumidorResp => {
                    console.log(
                      `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${venda.idEmpresa}/cpfcnpj/${venda.cpf}`,
                    );

                    if (consumidorResp) {
                      console.log(consumidorResp.data);
                      if (consumidorResp.data) {
                        setConsumidor(consumidorResp.data);
                        setConsumidorIdentificado(true);
                      }
                    }
                  })
              }
            }

            if (produtos.length == 0) {
              const pagamentosAux = [];
              venda.pagamentos.map(pagamento => {

                const novoPagamento = {
                  tipo: pagamento.codigoFiscal,
                  tipoNome: pagamento.descricao,
                  valor: pagamento.valor,
                }
                pagamentosAux.push(novoPagamento);

              })
              console.log('Pagamentos');
              console.log(pagamentosAux);
              setPagamentos(pagamentosAux);



              let pagItemAux = new Array();
              pagamentosAux.map(pagamento => {
                const pagamentoFormatado = {
                  tPag: pagamento.tipo,
                  vPag: pagamento.valor.toFixed(2),
                  xPag: pagamento.tipoNome,
                };
                pagItemAux.push(pagamentoFormatado);
              });
              setPagItem(pagItemAux);

              setPagamentoConcluido(true);
            }


            console.log('orcamento');
            console.log(JSON.parse(venda.jsonDocFiscal).det.detItem);

            // pegue e normalize o detItem
            const detItems = JSON.parse(venda.jsonDocFiscal)?.det?.detItem;
            const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

            // índice por cProd (chave como string para evitar problemas de tipo)
            const detByCProd = new Map(
              detArray.map(it => [String(it?.prod?.cProd), it])
            );

            detArray.map(async item => {
              console.log(item);

              const produto = item?.prod;
              try {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                let response = await axios.get(
                  `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${venda.idEmpresa
                  }/produtos/${produto.cProd}?page=${0}`,
                  options,
                );

                const produtosAux = produtos;
                if (response.data) {
                  console.log(response.data);

                  response.data.preco = produto.vUnCom;
                  response.data.quantidade = produto.qCOM;
                  response.data.acrescimo = produto.vOutro_item;
                  response.data.desconto = produto.vDesc;
                  response.data.valorAcrescimo = produto.vOutro_item;
                  response.data.valorDesconto = produto.vDesc;
                  response.data.frete = produto.vFrete ? produto.vFrete : 0;
                  response.data.observacao = item?.infADProd || '';
                  response.data.idVendedor = produto.idVendedor || '';

                  response.data.nItemPed = item?.prod.nItemPed || '';
                  response.data.xPed_item = item?.prod.xPed_item || '';

                  console.log(response.data);
                  produtosAux.push(response.data);
                  CalcularTotais();
                }

                setProdutos(produtosAux);
              } catch (error) {
                setIsLoading(false);
                setVendaPuxada(false);
                console.error('Erro ao fazer a requisição:', error);
              }
            })



            /* orcamento.itens.map(async prod => {
               try {
                 const options = {
                   headers: {
                     Accept: 'application/json',
                     'Content-Type': 'application/json',
                     Authorization: 'Bearer ' + accessToken,
                   },
                 };
                 console.log(
                   `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                   }/produtos/${prod.idReferencialProduto}?page=${0}`,
                 );
                 const response = await axios.get(
                   `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                   }/produtos/${prod.idReferencialProduto}?page=${0}`,
                   options,
                 );
   
                 const produtosAux = produtos;
                 if (response.data) {
                   console.log(response.data);
                   console.log(prod);
                   response.data.preco = prod.valorUnitario;
                   response.data.quantidade = prod.quantidade;
                   response.data.acrescimo = prod.valorTotalAcrescimo;
                   response.data.desconto = prod.valorTotalDesconto;
                   response.data.valorAcrescimo = prod.valorTotalAcrescimo;
                   response.data.valorDesconto = prod.valorTotalDesconto;
                   response.data.frete = prod.vfrete ? prod.vfrete : 0;
                   response.data.observacao = detByCProd.get(prod.idReferencialProduto).prod.observacao;
                   console.log(response.data);
                   produtosAux.push(response.data);
                   CalcularTotais();
                 }
   
                 setProdutos(produtosAux);
               } catch (error) {
                 setIsLoading(false);
                 console.error('Erro ao fazer a requisição:', error);
               }
             });*/
            //   setIdOrcamento(venda.id);

            let acresDescFreteAux = acresDescFrete;
            acresDescFreteAux.frete = venda.valorFrete;
            setAcresDescFrete(acresDescFreteAux);
            console.log('venda');
            console.log(venda);
            console.log('produtos');
            console.log(produtos);
            setIsLoading(false);
          }}
        />

      ) : isBuscarDelivery ? (
        <BuscarDelivery
          onItemPress={trataProdutos}
          setPagamentoConcluido={setPagamentoConcluido}
          setPagamentos={setPagamentos}
          closeModal={handleVoltarBuscarDeliveryClick}
          setAcresDescFrete={setAcresDescFrete}
          acresDescFrete={acresDescFrete}
          setTravarAcrescimoDescFrete={setTravarAcrescimoDescFrete}
          setDocumentoCupom={setDocumentoCupom}
          setNomeCupom={setNomeCupom}
          consumidorIntegrado={consumidorIntegrado}
          setConsumidorIntegrado={setConsumidorIntegrado}
          consumidor={consumidor}
          setConsumidor={setConsumidor}
          setTokenPedidoTechsapp={setTokenPedidoTechsapp}
          setVendaPuxada={setVendaPuxada}
        ></BuscarDelivery>
      ) : isPesquisar ? (
        <Pesquisar
          onItemPress={trataProdutos}
          setPagamentoConcluido={setPagamentoConcluido}
          setPagamentos={setPagamentos}
          closeModal={handleVoltarClick}
          validarEstoque={true}
          disabled={idPedidoMkt}
        ></Pesquisar>
      ) : isLerCodigo ? (
        /*  <Leitor
        closeModal={() => {
          setIsLerCodigo(false);
        }}
        onItemPress={trataProdutos}
        setPagamentoConcluido={setPagamentoConcluido}
        setPagamentos={setPagamentos}>
      </Leitor>*/
        <LeitorQRCode />
      ) :
        isFinalizarVenda ? (<FinalizarVenda
          closeModal={() => { setIsFinalizarVenda(false) }}
          onItemPress={trataProdutos}
          setConsumidorIdentificado={setConsumidorIdentificado}
          consumidorIdentificado={consumidorIdentificado}
          nomeCupom={nomeCupom}
          documentoCupom={documentoCupom}
          setNomeCupom={setNomeCupom}
          setDocumentoCupom={setDocumentoCupom}
          consumidor={consumidor}
          setConsumidor={setConsumidor}
          precoTotal={precoTotal}
          pagamentoConcluido={pagamentoConcluido}
          setPagamentoConcluido={setPagamentoConcluido}
          pagamentos={pagamentos}
          setPagamentos={setPagamentos}
          produtos={produtos}
          setProdutos={setProdutos}
          subTotal={subTotal}
          CalcularTotais={CalcularTotais}
          acresDescFrete={acresDescFrete}
          setAcresDescFrete={setAcresDescFrete}
          totalDescontos={totalDescontos}
          totalAcrescimos={totalAcrescimos}
          acresDescFreteConcluido={acresDescFreteConcluido}
          setAcresDescFreteConcluido={setAcresDescFreteConcluido}
          setPagItem={setPagItem}
          pagItem={pagItem}
          travarAcrescimoDescFrete={travarAcrescimoDescFrete}
          cpfIntegracao={cpfIntegracao}
          tokenPedidoTechsapp={tokenPedidoTechsapp}
          setTokenPedidoTechsapp={setTokenPedidoTechsapp}
          formasDePagamento={formasDePagamento}
          idVendedorOrcamento={idVendedorOrcamento}
          idOrcamento={idOrcamento}
          setVendaPuxada={setVendaPuxada}
          setIdPedidoMkt={setIdPedidoMkt}
          idPedidoMkt={idPedidoMkt}

        ></FinalizarVenda>) : (
          isModalVisibleItem ? (
            <ModalItemSelecionado
              isVisible={isModalVisibleItem}
              onClose={() => setModalVisibleItem(false)}
              onSave={updatedProduto => {
                console.log(updatedProduto);
                produtos[updatedProduto.index] = updatedProduto;
                //produto = updatedProduto;
                setRecalcular(!recalcular);
                setPagamentoConcluido(false);
                setPagamentos([]);
              }}
              onDelete={item => {
                produtos.splice(item.index, 1);
                setRecalcular(!recalcular);
                setPagamentoConcluido(false);
                setPagamentos([]);
              }}
              produto={selectedProduto}
            />
          ) : (
            // Caso contrário, exibe a tela de vendas
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                {/* <button
              style={{
                flex: 1,
                marginRight: '10px',
                backgroundColor: '#800080',
                color: '#fff',
                padding: '15px',
                borderRadius: '5px',
                border: 'none',
                fontSize: '16px',
              }}
              onClick={()=>{setIsLerCodigo(true)}} 
            >
              <span style={{ display: 'block', fontSize: '24px' }}>📷</span>
              Ler Código
            </button>*/}
                <button
                  onClick={handlePesquisarClick}
                  style={{
                    flex: 1,
                    marginRight: '10px',
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: idPedidoMkt ? 'not-allowed' : 'pointer',
                  }}

                  disabled={idPedidoMkt}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>🔍</span>
                  Pesquisar
                </button>
                <button
                  style={{
                    flex: 1,
                    backgroundColor: '#90ee90',
                    color: '#000',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}

                  onClick={() => {
                    if (produtos.length > 0 && !temPrecoZeradoOuNulo(produtos)) {
                      setIsFinalizarVenda(true);
                    } else {
                      window.alert(
                        produtos.length === 0
                          ? 'Adicione produtos à compra!'
                          : 'Existem produtos com preço zerado ou inválido!'
                      );
                    }
                  }}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
                  Finalizar Venda
                </button>

              </div>
              <div style={{ display: 'flex', marginBottom: '20px', gap: '10px' }}>
                <button
                  style={{
                    flex: 1,
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                  }}
                  disabled={vendaPuxada}
                  onClick={() => {
                    setIsBuscarOrcamento(true);
                  }}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                  Buscar Orçamento
                </button>

                <button
                  style={{
                    flex: 1,
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                  }}
                  disabled={vendaPuxada}
                  onClick={() => {
                    setIsBuscarVenda(true);
                  }}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                  Buscar Venda
                </button>
                <button
                  style={{
                    flex: 1,
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                  }}
                  disabled={vendaPuxada}
                  onClick={() => {
                    setIsBuscarDelivery(true);
                  }}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>🏍️</span>
                  Buscar Delivery
                </button>
                <button
                  style={{
                    flex: 1,
                    backgroundColor: '#000',
                    color: '#fff',
                    padding: '15px',
                    borderRadius: '5px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                  }}
                  disabled={vendaPuxada}
                  // disabled={true}
                  onClick={() => {
                    setIsBuscarPedidoMkt(true);
                  }}
                >
                  <span style={{ display: 'block', fontSize: '24px' }}>🛒</span>
                  MarketPlace
                </button>
              </div>



              <div style={{ backgroundColor: '#d3d3d3', padding: '15px', borderRadius: '5px' }}>
                {/* Linha 1: Data e Operador */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>{getDataAtual()}</p>
                  <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>{`Operador: ${operador}`}</p>
                </div>

                {/* Linha 2: Totais */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>
                    Total da Venda: {totalSemFrete.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </p>
                  <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>
                    {`Total de Itens na Venda: ${Number(quantidadeDeItens || 0).toLocaleString('pt-BR', {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })
                      }`}
                  </p>
                </div>

                {/* Input centralizado com foco automático */}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                  <input
                    ref={inputRef}
                    type="text"
                    placeholder="Digite o código de barras"
                    disabled={idPedidoMkt ? true : false}
                    onKeyDown={handleKeyDown}
                    style={{
                      width: '250px',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      fontSize: '14px',
                      textAlign: 'center',
                    }}
                  />
                </div>

                {/* Exibição da "resposta" do endpoint simulado */}
                {mensagem && (
                  <div style={{ marginTop: '10px', textAlign: 'center', color: '#333', fontWeight: 'bold' }}>
                    {mensagem}
                  </div>
                )}
              </div>



              {[...produtos].reverse().map((produto, index) => {
                const originalIndex = produtos.length - 1 - index;

                return (
                  <div
                    key={produto._uid}
                    className={`cardT ${produto.travado ? 'travado' : ''}`}
                    onClick={() => {
                      console.log(originalIndex);
                      if (!produto.travado) openModalItem({ ...produto, index: originalIndex });
                    }}
                    style={{ display: "flex", width: "100%" }}
                  >
                    {/* ESQUERDA - 60% */}
                    <div style={{ width: "60%" }}>
                      <span className="cardTextNome">{produto.nome}</span><br />
                      <span className="cardText">{`${produto.ean}`}</span><br />
                      <span className="cardText">
                        {`${Number(produto.quantidade || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })} ${produto.unidade || 'UN'} X ${produto.preco.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} = ${(produto.quantidade * produto.preco).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} - ${parseFloat(produto.valorDesconto).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} + ${parseFloat(produto.valorAcrescimo).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} = ${(parseFloat(produto.quantidade) * parseFloat(produto.preco)
                          - parseFloat(produto.valorDesconto) + parseFloat(produto.valorAcrescimo)
                        ).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                      </span>
                    </div>

                    {/* DIREITA - 40% */}
                    <div style={{ width: "40%", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                      <span className="cardText">
                        {produto.observacao || <i style={{ color: "#aaa" }}>Sem observação</i>}
                      </span>
                    </div>
                  </div>
                );
              })}

            </div>
          )
        )}
    </div>
  );
};

export default TelaVendas;
